import { Component, EventEmitter, Output, ViewChild } from "@angular/core";
import { FormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import _ from "lodash";
import { ToastrService } from "ngx-toastr";
import { InsuranceCompany } from "src/app/models/auxiliary/insurance-company.model";
import { InsuranceCompanyService } from "src/app/sections/auxillary-tables/insurance-company-table/services/insurance-company.service";
import { CommonUIService } from "src/app/sections/common/services/common.ui.service";

@Component({
  selector: "app-insurance-company-add-modal",
  templateUrl: "./insurance-company-add-modal.component.html",
  styleUrls: ["./insurance-company-add-modal.component.scss"],
})
export class InsuranceCompanyAddModalComponent {
  @ViewChild("modalLargeNew", { static: false }) child;
  @Output() close: EventEmitter<any> = new EventEmitter();

  isEdit = false;
  submitted = false;
  insuranceCompany: InsuranceCompany;
  insuranceCompanyForm: FormGroup;

  validationMessages = {};

  constructor(
    private insuranceCompanyService: InsuranceCompanyService,
    private translationService: TranslateService,
    private toastService: ToastrService,
    private formBuilder: UntypedFormBuilder,
    private commonUiService: CommonUIService
  ) {
    this.insuranceCompany = new InsuranceCompany();
  }

  ngOnInit() {
    this.checkIfEditOrAdd();
  }

  public show(insuranceCompanyData): void {
    this.child.show();
    this.submitted = false;
    this.insuranceCompany = insuranceCompanyData;
    this.insuranceCompanyForm.reset();
    this.checkIfEditOrAdd();
  }

  checkIfEditOrAdd() {
    if (!this.insuranceCompany.id) {
      this.initializeForAddInsuranceCompany();
      this.isEdit = false;
      return;
    }
    this.initializeForEditInsuranceCompany();
    this.isEdit = true;
  }

  initializeForAddInsuranceCompany() {
    this.insuranceCompanyForm = this.formBuilder.group({
      description: ["", [Validators.required]],
    });
  }

  initializeForEditInsuranceCompany() {
    this.insuranceCompanyForm = this.formBuilder.group({
      description: [this.insuranceCompany.description, [Validators.required]],
    });
  }

  onSave() {
    this.submitted = true;
    if (
      !this.commonUiService.validateForm(
        this.insuranceCompanyForm,
        this.validationMessages
      )
    ) {
      return;
    }
    if (this.isEdit) {
      this.update(this.insuranceCompanyForm.value);
      return;
    }
    this.save(this.insuranceCompanyForm.value);
  }

  private returnResponse(data?: InsuranceCompany) {
    this.close.emit(data);
    this.child.hide();
  }

  save(insuranceCompany: InsuranceCompany) {
    insuranceCompany.status = true;
    this.insuranceCompanyService
      .saveInsuranceCompany(insuranceCompany)
      .subscribe(
        (_data: any) => {
          this.successToast("saveInsuranceCompany");
          this.returnResponse(_data?._data);
        },
        (error) => {
          this.failToast(error._message);
        }
      );
  }

  update(insuranceCompany: InsuranceCompany) {
    insuranceCompany.id = this.insuranceCompany.id;
    insuranceCompany.status = this.insuranceCompany.status;
    this.insuranceCompanyService
      .updateInsuranceCompany(insuranceCompany.id, insuranceCompany)
      .subscribe(
        (_data: any) => {
          this.successToast("updateInsuranceCompany");
          this.returnResponse(_data?._data);
        },
        (error) => {
          this.failToast(error._message);
        }
      );
  }

  successToast(messageTranslationKey) {
    this.translationService
      .get(["success", messageTranslationKey])
      .subscribe((translations: any) => {
        this.toastService.success(
          translations[messageTranslationKey],
          translations.success,
          {
            timeOut: 5000,
            progressBar: true,
            closeButton: true,
            progressAnimation: "increasing",
            positionClass: "toast-bottom-right",
          }
        );
      });
  }

  failToast(message) {
    this.translationService
      .get(["errorTitle", message])
      .subscribe((translations: any) => {
        this.toastService.error(translations[message], translations.success, {
          timeOut: 5000,
          progressBar: true,
          closeButton: true,
          progressAnimation: "increasing",
          positionClass: "toast-bottom-right",
        });
      });
  }

  get description() {
    return this.insuranceCompanyForm.get("description");
  }
}
